// A post is flagged "new" (virtual, dynamic tag) for this many days after its
// publication date. Evaluated client-side so the badge stays accurate over time
// without needing a site rebuild.
export const NEW_WINDOW_DAYS = 14;

const NEW_WINDOW_MS = NEW_WINDOW_DAYS * 24 * 60 * 60 * 1000;

export function isRecentPost(date: string): boolean {
  const published = new Date(date).getTime();
  if (Number.isNaN(published)) return false;
  const age = Date.now() - published;
  return age >= 0 && age < NEW_WINDOW_MS;
}
